import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-2 pb-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "お仕事お疲れ様でした！", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-danger" }, "\n        未退勤のお仕事があります\n      ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-danger" }, "\n        退勤予定日を過ぎているため、勤怠変更申請を行ってください\n      ", -1)
const _hoisted_5 = { class: "my-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "\n        給与は勤怠変更申請が承認され次第、申請内容をもとにウォレットに反映されます\n      ", -1)

import type { PropType } from "vue";
import { computed } from "vue";
import AppButton from "@/components/atoms/button/AppButton.vue";
import { Application } from "@/types/order/Application";
import WorkInfoTable from "@/views/applications/organisms/WorkInfoTable.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LeavingWorkNeededWithAttendanceCorrectionModal',
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  application: {
    type: Object as PropType<Application>,
    required: true
  }
},
  setup(__props) {

const props = __props;



const attendanceCorrectionRoute = computed(() => ({
  name: "AttendanceCorrection",
  params: {
    applicationId: props.application.id.toString()
  }
}));

return (_ctx: any,_cache: any) => {
  const _component_BModal = _resolveComponent("BModal")!

  return (_openBlock(), _createBlock(_component_BModal, {
    visible: __props.visible,
    "hide-header": "",
    "hide-footer": "",
    "no-close-on-backdrop": "",
    "no-close-on-esc": "",
    centered: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createTextVNode(),
        _hoisted_3,
        _createTextVNode(),
        _hoisted_4,
        _createTextVNode(),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(WorkInfoTable, {
            application: __props.application,
            isNotShowFinishWorkTime: true
          }, null, 8, ["application"])
        ]),
        _createTextVNode(),
        _hoisted_6,
        _createTextVNode(),
        _createVNode(AppButton, {
          block: "",
          to: attendanceCorrectionRoute.value,
          class: "mt-3"
        }, {
          default: _withCtx(() => [
            _createTextVNode("\n        勤怠変更申請する\n      ")
          ], undefined, true),
          _: 1
        }, 8, ["to"])
      ])
    ], undefined, true),
    _: 1
  }, 8, ["visible"]))
}
}

})